export default "__VITE_ASSET__DZTEB5N0__"